/** Public dashboard origin. Local previews can override this without changing source. */
export const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.foxet.ai';

/** One canonical entry for Foxet's own public product experience. */
export const DEMO_CTA_HREF = `${APP_URL}/l/foxet-demo/foxet-ai-v1-1`;
